import React from "react"
import { Button, KIND } from "baseui/button"
import { ChevronLeft, ChevronRight } from "baseui/icon"
import Slider from "react-slick"
import { Block } from "baseui/block"
import PostCard from "./PostCard"

type RelatedPosts = {
  posts: any[]
}

const RelatedPosts = ({ posts }: RelatedPosts) => {
  const calculateSlide = (number: number) => {
    const slideToShow = posts.length >= number ? number : posts.length
    return {
      slidesToShow: slideToShow,
      slidesToScroll: slideToShow,
    }
  }

  const Arrow = ({ direction, onClick }: any) => {
    return (
      <Button
        kind={KIND.minimal}
        onClick={onClick}
        overrides={{
          BaseButton: {
            style: {
              position: "absolute",
              top: "28%",
              zIndex: 100,
              ...(direction === "right"
                ? { right: "-40px" }
                : { left: "-40px" }),
              ":active": {
                backgroundColor: "transparent",
              },
            },
          },
        }}
      >
        {direction === "right" ? (
          <ChevronRight
            size={35}
            color={"white"}
            overrides={{ Svg: { style: { cursor: "pointer" } } }}
          />
        ) : (
          <ChevronLeft
            size={35}
            color={"white"}
            overrides={{ Svg: { style: { cursor: "pointer" } } }}
          />
        )}
      </Button>
    )
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    ...calculateSlide(4),
    nextArrow: <Arrow direction={"right"} />,
    prevArrow: <Arrow direction={"left"} />,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          ...calculateSlide(2),
        },
      },
    ],
  }
  return (
    <Slider {...settings}>
      {posts.map((post: any) => (
        <Block key={post.id}>
          <Block paddingLeft={["5px", "10px"]} paddingRight={["5px", "10px"]}>
            <PostCard post={post} imgCover />
          </Block>
        </Block>
      ))}
    </Slider>
  )
}

export default RelatedPosts
